export default __webpack_public_path__ + "static/media/admin-svgrepo-com.01d9c4aa.svg";